"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOverdue = exports.getDueDateGroupByKey = void 0;
const texts_1 = require("../texts");
const intl_1 = require("../locale/intl");
const date_1 = require("./date");
const isAfter_1 = __importDefault(require("date-fns/isAfter"));
const endOfDay_1 = __importDefault(require("date-fns/endOfDay"));
const date_fns_tz_1 = require("date-fns-tz");
const getDueDateGroupByKey = (value, userPreferences) => {
    var _a, _b;
    if (!((_a = value === null || value === void 0 ? void 0 : value.to_date) === null || _a === void 0 ? void 0 : _a.date)) {
        return "";
    }
    if (value === null || value === void 0 ? void 0 : value.status_is_completed) {
        return (0, intl_1.$t)(texts_1.dueDateFieldText.complete);
    }
    const timezone = (_b = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.timezone.value) !== null && _b !== void 0 ? _b : "UTC";
    const dueDate = (0, date_fns_tz_1.utcToZonedTime)(value.to_date.date, timezone);
    if (!dueDate) {
        return "";
    }
    const now = (0, date_1.getNow)(timezone);
    if (isOverdue(dueDate, now, value.to_date.include_time)) {
        return (0, intl_1.$t)(texts_1.dueDateFieldText.overdue);
    }
    return (0, intl_1.$t)(texts_1.dueDateFieldText.in_progress);
};
exports.getDueDateGroupByKey = getDueDateGroupByKey;
function isOverdue(dueDate, now, includeTime) {
    if (includeTime) {
        return (0, isAfter_1.default)(now, dueDate);
    }
    return (0, isAfter_1.default)(now, (0, endOfDay_1.default)(dueDate));
}
exports.isOverdue = isOverdue;
